module.exports = __webpack_public_path__ + "img/47.4ca2c51a.png";